import { render, staticRenderFns } from "./IntegralGoodsDetails.vue?vue&type=template&id=b9224cb0&scoped=true"
import script from "./IntegralGoodsDetails.vue?vue&type=script&lang=js"
export * from "./IntegralGoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./IntegralGoodsDetails.vue?vue&type=style&index=0&id=b9224cb0&prod&lang=scss&scoped=true"
import style1 from "./IntegralGoodsDetails.vue?vue&type=style&index=1&id=b9224cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9224cb0",
  null
  
)

export default component.exports